require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-fox-road-branch-members.json") })
        }
      }, "path---articles-fox-road-branch-members");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-fox-road-branch-members!./.cache/json/articles-fox-road-branch-members.json
// module id = 1679
// module chunks = 231608221292675